import { render, staticRenderFns } from "./NotificacaoLogIndex.vue?vue&type=template&id=313b518d&scoped=true&"
import script from "./NotificacaoLogIndex.vue?vue&type=script&lang=js&"
export * from "./NotificacaoLogIndex.vue?vue&type=script&lang=js&"
import style0 from "./NotificacaoLogIndex.vue?vue&type=style&index=0&id=313b518d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313b518d",
  null
  
)

export default component.exports